import React, { useEffect } from 'react';
import Validator from '../../../../components/forms/validate';
import { Button } from '@syneto/compass-react';
import { reduxForm } from 'redux-form';
import Form from '../../../../components/forms/form';
import { connect } from 'react-redux';
import { unflatten } from 'flat';
import { getOs6Settings, editOs6Settings } from './data/actions';
import {
	pushDangerNotification,
	pushSuccessfulNotification
} from '../../../../data/notifications/actions';

const validate = (values) => {
	const validator = new Validator(values, {
		trialDuration: ['required', 'integer'],
		os6GuideUrl: ['url'],
		os6IsoUrl: ['url'],
		os6OvaUrl: ['url'],
		os6UsbUrl: ['url'],
		os6HyperionInstallationGuideUrl: ['url'],
		os6EsxiInstallationGuideUrl: ['url'],
		expectedOsShipmentVersion: [],
	});

	return validator.fails() ? unflatten(validator.errors.all()) : {};
};

let AdminSettingsOS6Tab = (props) => {
	const { handleSubmit, submitting, invalid } = props;

	useEffect(() => {
		props.activeKey === 'os6Settings' && props.getOs6Settings();
		props.reset('os6Settings');
	}, [props.activeKey]);

	function submit(formValues) {
		const transformedValues = {
			...formValues,
			trialDuration: parseInt(formValues.trialDuration, 10)
		};

		props.editOs6Settings(transformedValues).then(() => {
			props.pushSuccessfulNotification('OS6 settings updated.');
		}).catch(() => {
			props.pushDangerNotification('Failed to save OS6 settings.');
		});
	}

	return (
		<form>
			<fieldset className="mb-5">
				<h1 className="mb-1">Software Only Configuration</h1>
				<p className="text-secondary mb-4 text-value">
          Configure OS6 specific settings and parameters.
				</p>
				<Form.text
					name="trialDuration"
					label="Feature trial length (days)"
				/>
			</fieldset>

			<fieldset className="mb-5">
				<h1 className="mb-1">Distribution Links</h1>
				<p className="text-secondary mb-4 text-value">
					Configure OS6 software download URLs.
				</p>
				<Form.text
					name="os6GuideUrl"
					label="OS6 Guide URL"
				/>
				<Form.text
					name="os6IsoUrl"
					label="OS6 ISO URL"
				/>
				<Form.text
					name="os6OvaUrl"
					label="OS6 OVA URL"
				/>
				<Form.text
					name="os6UsbUrl"
					label="OS6 USB image URL"
				/>
				<Form.text
					name="os6HyperionInstallationGuideUrl"
					label="SynetoOS 6 with Hyperion installation guide URL"
				/>
				<Form.text
					name="os6EsxiInstallationGuideUrl"
					label="SynetoOS 6 with ESXi installation guide URL"
				/>
			</fieldset>

			<fieldset className="mb-5">
				<h1 className="mb-1">Expected Shipment Software Version</h1>
				<p className="text-secondary mb-4 text-value">
				Minimum software version that should be installed by Syneto hardware integrators. This value will be validated as part of the assembly test run.
				</p>
				<Form.text
					name="expectedOsShipmentVersion"
					label="Expected software version"
					description="Minimum software version that should be installed by Syneto hardware integrators. This value will be validated as part of the assembly test run."
				/>
			</fieldset>

			<Button disabled={submitting || invalid} onClick={handleSubmit(submit)} type="submit">
				{!submitting ? 'Save' : 'Saving...'}
			</Button>
		</form>
	);
};

AdminSettingsOS6Tab = reduxForm({
	form: 'os6Settings',
	enableReinitialize: true,
	validate: validate,
})(AdminSettingsOS6Tab);

const mapStateToProps = (state) => {
	const { os6Settings } = state.adminSettings;

	return {
		initialValues: {
			trialDuration: os6Settings?.trialDuration?.toString() ?? '0',
			os6GuideUrl: os6Settings?.os6GuideUrl ?? '',
			os6IsoUrl: os6Settings?.os6IsoUrl ?? '',
			os6OvaUrl: os6Settings?.os6OvaUrl ?? '',
			os6UsbUrl: os6Settings?.os6UsbUrl ?? '',
			os6HyperionInstallationGuideUrl: os6Settings?.os6HyperionInstallationGuideUrl ?? '',
			os6EsxiInstallationGuideUrl: os6Settings?.os6EsxiInstallationGuideUrl ?? '',
			expectedOsShipmentVersion: os6Settings?.expectedOsShipmentVersion ?? '',
		},
	};
};

export default connect(mapStateToProps, {
	getOs6Settings,
	editOs6Settings,
	pushSuccessfulNotification,
	pushDangerNotification,
})(AdminSettingsOS6Tab);
